import {CircleAndTitle} from 'components'
import {Colors} from 'utils'

export const Branches = ({}) => {
    return (
        <div>

            <div>
                <CircleAndTitle number={5} back={Colors.ThemeOrange} title={'Branches'}/>
            </div>
            <div style={{marginLeft: '45px', marginTop: '24px'}}>
                {/*<OfficesTable/>*/}
            </div>

        </div>
    )
}